/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import SettingService from '../../services/SettingService';
import SettingTypes from '../types/SettingTypes';

function getMailVariable() {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_SETTING_MAIL_VARIABLE_REQUEST });
    try {
      const res = await SettingService.getMailVariable();
      dispatch({
        type: SettingTypes.GET_SETTING_MAIL_VARIABLE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_SETTING_MAIL_VARIABLE_ERROR,
          error: error.response
        });
      }
    }
  };
}

//* get all setting list items
function getPaypal() {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_PAYMENT_PAYPAL_REQUEST });
    try {
      const res = await SettingService.getPaypal();
      dispatch({
        type: SettingTypes.GET_PAYMENT_PAYPAL_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_PAYMENT_PAYPAL_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getStripe() {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_PAYMENT_STRIPE_REQUEST });
    try {
      const res = await SettingService.getStripe();
      dispatch({
        type: SettingTypes.GET_PAYMENT_STRIPE_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_PAYMENT_STRIPE_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getAuthorizeNet() {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_PAYMENT_AUTHORIZENET_REQUEST });
    try {
      const res = await SettingService.getAuthorizeNet();
      dispatch({
        type: SettingTypes.GET_PAYMENT_AUTHORIZENET_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_PAYMENT_AUTHORIZENET_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getBankOfAmerica() {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_PAYMENT_BANKOFAMERICA_REQUEST });
    try {
      const res = await SettingService.getBankOfAmerica();
      dispatch({
        type: SettingTypes.GET_PAYMENT_BANKOFAMERICA_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_PAYMENT_BANKOFAMERICA_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getClover() {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_PAYMENT_CLOVER_REQUEST });
    try {
      const res = await SettingService.getClover();
      dispatch({
        type: SettingTypes.GET_PAYMENT_CLOVER_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_PAYMENT_CLOVER_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updatePaypal(postData, setErrors, submitting) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_PAYMENT_PAYPAL_REQUEST });
    try {
      const res = await SettingService.updatePaypal(postData);
      dispatch({
        type: SettingTypes.UPDATE_PAYMENT_PAYPAL_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getPaypal()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        console.log(error.response, 'dsfdsfdsf');
        dispatch({
          type: SettingTypes.UPDATE_PAYMENT_PAYPAL_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function updateStripe(postData, setErrors, submitting) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_PAYMENT_STRIPE_REQUEST });
    try {
      const res = await SettingService.updateStripe(postData);
      dispatch({
        type: SettingTypes.UPDATE_PAYMENT_STRIPE_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getStripe()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_PAYMENT_STRIPE_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function updateAuthorizeNet(postData, setErrors, submitting) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_PAYMENT_AUTHORIZENET_REQUEST });
    try {
      const res = await SettingService.updateAuthorizeNet(postData);
      dispatch({
        type: SettingTypes.UPDATE_PAYMENT_AUTHORIZENET_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getAuthorizeNet()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_PAYMENT_AUTHORIZENET_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getVeem() {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_PAYMENT_VEEM_REQUEST });
    try {
      const res = await SettingService.getVeem();
      dispatch({
        type: SettingTypes.GET_PAYMENT_VEEM_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_PAYMENT_VEEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updateVeem(postData, setErrors, submitting) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_PAYMENT_VEEM_REQUEST });
    try {
      const res = await SettingService.updateVeem(postData);
      dispatch({
        type: SettingTypes.UPDATE_PAYMENT_VEEM_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getVeem()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_PAYMENT_VEEM_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function updateBankOfAmerica(postData, setErrors, submitting) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_PAYMENT_BANKOFAMERICA_REQUEST });
    try {
      const res = await SettingService.updateBankOfAmerica(postData);
      dispatch({
        type: SettingTypes.UPDATE_PAYMENT_BANKOFAMERICA_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getBankOfAmerica()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_PAYMENT_BANKOFAMERICA_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function updateClover(postData, setErrors, submitting) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_PAYMENT_CLOVER_REQUEST });
    try {
      const res = await SettingService.updateClover(postData);
      dispatch({
        type: SettingTypes.UPDATE_PAYMENT_CLOVER_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getClover()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_PAYMENT_CLOVER_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getGeneralSettings() {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_GENERAL_SETTINGS_REQUEST });
    try {
      const res = await SettingService.getGeneralSettings();
      dispatch({
        type: SettingTypes.GET_GENERAL_SETTINGS_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_GENERAL_SETTINGS_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updateGeneralSettings(postData, setErrors, submitting) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_GENERAL_SETTINGS_REQUEST });
    try {
      const res = await SettingService.updateGeneralSettings(postData);
      dispatch({
        type: SettingTypes.UPDATE_GENERAL_SETTINGS_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getGeneralSettings()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_GENERAL_SETTINGS_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getUserProfile() {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_USER_PROFILE_REQUEST });
    try {
      const res = await SettingService.getUserProfile();
      dispatch({
        type: SettingTypes.GET_USER_PROFILE_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_USER_PROFILE_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updateUserProfile(postData, setErrors, submitting) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_USER_PROFILE_REQUEST });
    try {
      const res = await SettingService.updateUserProfile(postData);
      dispatch({
        type: SettingTypes.UPDATE_USER_PROFILE_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getUserProfile()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_USER_PROFILE_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getVerifyMail(code) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_VERIFY_MAIL_REQUEST });
    try {
      const res = await SettingService.getVerifyMail(code);
      dispatch({
        type: SettingTypes.GET_VERIFY_MAIL_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_VERIFY_MAIL_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updateChangePassword(postData, setErrors, submitting, closeModal) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_CHANGE_PASSWORD_REQUEST });
    try {
      const res = await SettingService.updateChangePassword(postData);
      dispatch({
        type: SettingTypes.UPDATE_CHANGE_PASSWORD_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      submitting(false);
      closeModal();
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_CHANGE_PASSWORD_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

//* get all department list items
function getAllBank(pageOption, sortData, keyword) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_BANK_LIST_REQUEST });
    try {
      const res = await SettingService.getAllBank(pageOption, sortData, keyword);
      dispatch({
        type: SettingTypes.GET_BANK_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_BANK_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

const bankQueryParams = (paginationModel, sortInfo, keyword) => ({
  type: SettingTypes.UPDATE_BANK_QUERY_PARAMS,
  payload: { paginationModel, sortInfo, keyword }
});

function addBank(postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.ADD_BANK_REQUEST });
    try {
      const res = await SettingService.addBank(postData);
      dispatch({ type: SettingTypes.ADD_BANK_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      navigate('/settings/bank');
      // setTimeout(() => dispatch(SettingAction.getAll()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.ADD_BANK_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getBankItem(code) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_BANK_ITEM_REQUEST });
    try {
      const res = await SettingService.getBankItem(code);
      dispatch({
        type: SettingTypes.GET_BANK_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_BANK_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updateBank(code, postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_BANK_REQUEST });
    try {
      const res = await SettingService.updateBank(code, postData);
      dispatch({
        type: SettingTypes.UPDATE_BANK_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      // setTimeout(() => dispatch(SettingAction.getAll()), 500);
      submitting(false);
      navigate('/settings/bank');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_BANK_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function deleteBankItem(code, closeModal) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.DELETE_BANK_REQUEST });
    try {
      const res = await SettingService.deleteBankItem(code);
      dispatch({
        type: SettingTypes.DELETE_BANK_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getAllBank()), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.DELETE_BANK_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

//* get all office Address list items
function getAllOffice(pageOption, sortData, keyword) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_OFFICE_LIST_REQUEST });
    try {
      const res = await SettingService.getAllOffice(pageOption, sortData, keyword);
      dispatch({
        type: SettingTypes.GET_OFFICE_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_OFFICE_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

const officeQueryParams = (paginationModel, sortInfo, keyword) => ({
  type: SettingTypes.UPDATE_OFFICE_QUERY_PARAMS,
  payload: { paginationModel, sortInfo, keyword }
});

function addOffice(postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.ADD_OFFICE_REQUEST });
    try {
      const res = await SettingService.addOffice(postData);
      dispatch({ type: SettingTypes.ADD_OFFICE_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      navigate('/settings');
      // setTimeout(() => dispatch(SettingAction.getAll()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.ADD_OFFICE_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getOfficeItem(code) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_OFFICE_ITEM_REQUEST });
    try {
      const res = await SettingService.getOfficeItem(code);
      dispatch({
        type: SettingTypes.GET_OFFICE_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_OFFICE_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updateOffice(code, postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_OFFICE_REQUEST });
    try {
      const res = await SettingService.updateOffice(code, postData);
      dispatch({
        type: SettingTypes.UPDATE_OFFICE_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      // setTimeout(() => dispatch(SettingAction.getAll()), 500);
      submitting(false);
      navigate('/settings');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_OFFICE_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function deleteOfficeItem(code, closeModal) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.DELETE_OFFICE_REQUEST });
    try {
      const res = await SettingService.deleteOfficeItem(code);
      dispatch({
        type: SettingTypes.DELETE_OFFICE_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getAllOffice()), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.DELETE_OFFICE_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

const signatureQueryParams = (paginationModel, sortInfo, keyword) => ({
  type: SettingTypes.UPDATE_SIGNATURE_QUERY_PARAMS,
  payload: { paginationModel, sortInfo, keyword }
});

//* get all Signature list items
function getAllSignature(pageOption, sortData, keyword) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_SIGNATURE_LIST_REQUEST });
    try {
      const res = await SettingService.getAllSignature(pageOption, sortData, keyword);
      dispatch({
        type: SettingTypes.GET_SIGNATURE_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_SIGNATURE_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

function addSignature(postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.ADD_SIGNATURE_REQUEST });
    try {
      const res = await SettingService.addSignature(postData);
      dispatch({ type: SettingTypes.ADD_SIGNATURE_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      navigate('/settings/signature');
      // setTimeout(() => dispatch(SettingAction.getAll()), 500);
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.ADD_SIGNATURE_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getSignatureItem(code) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.GET_SIGNATURE_ITEM_REQUEST });
    try {
      const res = await SettingService.getSignatureItem(code);
      dispatch({
        type: SettingTypes.GET_SIGNATURE_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.GET_SIGNATURE_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updateSignature(code, postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.UPDATE_SIGNATURE_REQUEST });
    try {
      const res = await SettingService.updateSignature(code, postData);
      dispatch({
        type: SettingTypes.UPDATE_SIGNATURE_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      // setTimeout(() => dispatch(SettingAction.getAll()), 500);
      submitting(false);
      navigate('/settings/signature');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: SettingTypes.UPDATE_SIGNATURE_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function deleteSignatureItem(code, closeModal) {
  return async (dispatch) => {
    dispatch({ type: SettingTypes.DELETE_SIGNATURE_REQUEST });
    try {
      const res = await SettingService.deleteSignatureItem(code);
      dispatch({
        type: SettingTypes.DELETE_SIGNATURE_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(SettingAction.getAllSignature()), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: SettingTypes.DELETE_SIGNATURE_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

const SettingAction = {
  getPaypal,
  updatePaypal,
  getStripe,
  updateStripe,
  getAuthorizeNet,
  updateAuthorizeNet,
  getMailVariable,
  getGeneralSettings,
  updateGeneralSettings,
  getUserProfile,
  updateUserProfile,
  getVerifyMail,
  updateChangePassword,
  getAllBank,
  addBank,
  updateBank,
  getBankItem,
  deleteBankItem,
  getAllOffice,
  addOffice,
  getOfficeItem,
  updateOffice,
  deleteOfficeItem,
  getAllSignature,
  addSignature,
  getSignatureItem,
  updateSignature,
  deleteSignatureItem,
  officeQueryParams,
  bankQueryParams,
  signatureQueryParams,
  updateVeem,
  getVeem,
  getClover,
  getBankOfAmerica,
  updateBankOfAmerica,
  updateClover
};

export default SettingAction;
